import { render, staticRenderFns } from "./qFields.vue?vue&type=template&id=b1c5001a&scoped=true"
import script from "./qFields.vue?vue&type=script&lang=js"
export * from "./qFields.vue?vue&type=script&lang=js"
import style0 from "./qFields.vue?vue&type=style&index=0&id=b1c5001a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c5001a",
  null
  
)

export default component.exports